import {
    GETMAPPINGBANKALLLIST_SUCCESS,
    GETMAPPINGBANKALLLIST_FAILED,
    RESET_GETMAPPINGBANKALLLIST,
    LOADING_GETMAPPINGBANKALLLIST,
    NETWORK_ERROR_GETMAPPINGBANKALLLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMAPPINGBANKALLLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMAPPINGBANKALLLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMAPPINGBANKALLLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMAPPINGBANKALLLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMAPPINGBANKALLLIST:
            return (state = initialState);
        default:
            return state;
    }
};
